import type { TableTranslations } from './table.translations.pl.ts';

export const tableTranslations: TableTranslations = {
  pagination: {
    next: 'Next',
    previous: 'Previous',
    totalPages: 'Pages',
    totalResults: 'Results',
    of: 'of',
    navigation: 'Page navigation',
    rowsPerPage: 'Rows per page:',
  },
};
